module.exports = __webpack_public_path__ + "img/photo-img.d2652277.png";